<template>
  <div>
    <transition  mode="out-in" name="fade" >
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/anchor/AnchorHome.vue